export const fightcampPremiumFlooringSale = {
  title: 'Premium Flooring',
  id: 'fightcamp_premium_flooring_sale',
  price: 9900,
  oldPrice: 19900,
  category: 'accessory',
  description: 'Protect your home from scuffs & scrapes with heavy-duty flooring. 8 inter-locking tiles provide shock absorption & friction to keep you safe.',
  img_url: '',
  marketplace_img_url: '/v4/fc-marketplace-accessory-flooring-001.png',
  tag: '50% Off',
  types: ['Setup'],
};
